<template>
  <basic-container>
    <avue-crud
      :option="option"
      :data="data"
      :page.sync="page"
      ref="crud"
      @row-del="rowDel"
      v-model="form"
      :permission="permissionList"
      @row-update="rowUpdate"
      @row-save="rowSave"
      :before-open="beforeOpen"
      @search-change="searchChange"
      @search-reset="searchReset"
      @refresh-change="refreshChange"
      @selection-change="selectionChange"
      @on-load="onLoad"
    >
      <template slot="menuLeft">
        <el-button
          type="danger"
          size="small"
          icon="el-icon-delete"
          plain
          v-if="permission.health_bsmeterdataquotations_delete"
          @click="handleDelete"
          >删 除
        </el-button>
      </template>
    </avue-crud>
  </basic-container>
</template>

<script>
import {
  getList,
  getDetail,
  submit,
  remove,
} from "@/api/health/bsmeterdataquotations";
import { mapGetters } from "vuex";

export default {
  data() {
    return {
      form: {},
      page: {
        pageSize: 10,
        currentPage: 1,
        total: 0,
      },
      selectionList: [],
      option: {
        tip: false,
        border: true,
        index: true,
        viewBtn: true,
        selection: true,
        column: [
          {
            label: "",
            prop: "id",
            rules: [
              {
                required: true,
                message: "请输入",
              },
            ],
          },
          {
            label: "排序",
            prop: "itemSort",
            rules: [
              {
                required: true,
                message: "请输入排序",
              },
            ],
          },
          {
            label: "项描述",
            prop: "detail",
            rules: [
              {
                required: true,
                message: "请输入项描述",
              },
            ],
          },
          {
            label: "类型:0：症状说明 1：疾病风险 2：治疗原则",
            prop: "type",
            rules: [
              {
                required: true,
                message: "请输入类型:0：症状说明 1：疾病风险 2：治疗原则 ",
              },
            ],
          },
          {
            label: "创建时间",
            prop: "createTime",
            rules: [
              {
                required: true,
                message: "请输入创建时间",
              },
            ],
          },
          {
            label: "修改时间",
            prop: "updateTime",
            rules: [
              {
                required: true,
                message: "请输入修改时间",
              },
            ],
          },
          {
            label: "乐观锁",
            prop: "revision",
            rules: [
              {
                required: true,
                message: "请输入乐观锁",
              },
            ],
          },
        ],
      },
      data: [],
    };
  },
  computed: {
    ...mapGetters(["permission"]),
    permissionList() {
      return {
        addBtn: this.permission.health_bsmeterdataquotations_add,
        viewBtn: this.permission.health_bsmeterdataquotations_view,
        delBtn: this.permission.health_bsmeterdataquotations_delete,
        editBtn: this.permission.health_bsmeterdataquotations_edit,
      };
    },
    ids() {
      const ids = [];
      this.selectionList.forEach((ele) => {
        ids.push(ele.id);
      });
      return ids.join(",");
    },
  },
  methods: {
    rowSave(row, done, loading) {
      submit(row)
        .then(() => {
          done();
          this.onLoad(this.page);
          this.$message({
            type: "success",
            message: "操作成功!",
          });
        })
        .catch(() => {
          loading();
        });
    },
    rowUpdate(row, index, done, loading) {
      submit(row)
        .then(() => {
          done();
          this.onLoad(this.page);
          this.$message({
            type: "success",
            message: "操作成功!",
          });
        })
        .catch(() => {
          loading();
        });
    },
    rowDel(row) {
      this.$confirm("确定将选择数据删除?", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          return remove(row.id);
        })
        .then(() => {
          this.onLoad(this.page);
          this.$message({
            type: "success",
            message: "操作成功!",
          });
        });
    },
    searchReset() {
      this.onLoad(this.page);
    },
    searchChange(params, done) {
      this.onLoad(this.page, params);
      done();
    },
    selectionChange(list) {
      this.selectionList = list;
    },
    refreshChange(data) {
      this.onLoad(this.page, data.searchForm);
    },
    handleDelete() {
      if (this.selectionList.length === 0) {
        this.$message.warning("请选择至少一条数据");
        return;
      }
      this.$confirm("确定将选择数据删除?", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          return remove(this.ids);
        })
        .then(() => {
          this.onLoad(this.page);
          this.$message({
            type: "success",
            message: "操作成功!",
          });
          this.$refs.crud.toggleSelection();
        });
    },

    beforeOpen(done, type) {
      if (["edit", "view"].includes(type)) {
        getDetail(this.form.id).then((res) => {
          this.form = res.data;
        });
      }
      done();
    },
    onLoad(page, params = {}) {
      getList(page.currentPage, page.pageSize, params).then((res) => {
        const data = res.data;
        this.page.total = data.total;
        this.data = data.records;
      });
    },
  },
};
</script>
